var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrap",class:_vm.themeClass},[_c('t-pagination',{staticClass:"pagination-item",attrs:{"classes":_vm.paginationClasses,"per-page":_vm.perPage,"total-items":_vm.total,"data-cy":_vm.dataCy},model:{value:(_vm.currentPageModel),callback:function ($$v) {_vm.currentPageModel=$$v},expression:"currentPageModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }